// extracted by mini-css-extract-plugin
export var circle = "_46-2";
export var icon = "_46-a";
export var iconHighlight = "_46-0";
export var lg = "_46-8";
export var md = "_46-7";
export var outline = "_46-4";
export var sm = "_46-6";
export var square = "_46-1";
export var xl = "_46-9";
export var xs = "_46-5";
export var xxs = "_46-3";